import React from 'react';
import { Parallax } from 'react-parallax';
import ThankYou from './ThankYou';

const ContactPage = () => (
  <div>
    <Parallax blur={0} bgImage="/images/illustration-02.jpg" bgImageAlt="Conatct Us" strength={120}>
      <div style={{ height: '300px' }} />
    </Parallax>
    <div className="container pb-2">
      <div className="row">
        {document.referrer === 'https://formspree.io/info@businessdna.net' ? (
          <ThankYou />
        ) : (
          <div>
            <h1 className="display-1 hidden-down pt-2">Contact Us</h1>
            <div className="col-xl-4 col-lg-4 col-md-5 pt-2 pb-2" />
          </div>
        )}
      </div>
    </div>
  </div>
);
export default ContactPage;



// WEBPACK FOOTER //
// ./src/components/ContactPage.js